<template>
  <main-dialog
    :is-visible.sync="computedIsVisible"
    modal-width="fit-content"
    agree-text="dialog.agreeSave"
    @modalClosed="onClose"
    @agree="onSave"
    :transition="false"
  >
    <template #body>
      <div class="tw:flexcol-4">
        <cropper-wrapper
          v-if="image"
          ref="cropper"
          :image-src="image"
          :key="image"
          :zoom-step="zoomStep"
          :zoom-steps="zoomSteps"
          v-bind="$attrs"
        />
        <div class="tw:w-full tw:flexrow-2 tw:items-center tw:pb-4">
          <v-icon small>mdi-minus</v-icon>
          <v-slider
            v-if="image"
            :value="0"
            @input="$event => $refs.cropper?.onZoomChanged($event)"
            :step="zoomStep"
            :max="zoomSteps"
            :min="0"
            hide-details
          ></v-slider>
          <v-icon small>mdi-plus</v-icon>
        </div>
      </div>
    </template>
  </main-dialog>
</template>

<script>
import CropperWrapper from '@/components/CropperWrapper';
export default {
  name: 'CropperDialog',
  components: {
    CropperWrapper,
    MainDialog: () => import('@/components/MainDialog'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'image',
    },
    src: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    image: null,

    // currentStep: 0,
    zoomStep: 0.025,
    zoomSteps: 20,
  }),
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
  watch: {
    isVisible: {
      async handler(nV) {
        if (!nV) return (this.image = null);
        await this.$nextTick();
        this.image = this.src;
      },
      immediate: true,
    },
  },
  methods: {
    onClose() {
      this.image = null;
      this.$emit('onClose');
    },
    async onSave() {
      const canvas = await this.$refs.cropper.generateImage({ height: this.$attrs.y, width: this.$attrs.x });
      canvas.toBlob(blob => {
        this.computedIsVisible = false;
        this.$emit('onSave', {
          name: this.name,
          file: new File([blob], this.name + '.png', { type: 'image/png' }),
        });
      }, 'image/png');
    },
  },
};
</script>
